<!--      <div *ngIf="formRecord&&!fieldValueMap['hiddenField']"-->
<!--        [class]="(fieldConfig.class?fieldConfig.class:'') +-->
<!--         ' field p-field'+(fieldConfig.type===FieldTypes.CHECKBOX?'-checkbox':'')+' col-12 md:col-'+fieldConfig.column"-->
<!--           >-->
<div [class]="'dispatcher-container '+(fieldConfig.leftButton||fieldConfig.rightButton?'p-inputgroup':'')
                +(fieldConfig.fieldIconLeft?'p-input-icon-left':'')
                +(fieldConfig.fieldIconRight?'p-input-icon-right':'')"
     [style.width]="fieldValueMap['style']">
  <i *ngIf="fieldConfig.fieldIconLeft" [class]="fieldConfig.fieldIconLeft"></i>
  <i *ngIf="fieldConfig.fieldIconRight" [class]="fieldConfig.fieldIconRight"></i>

  <!--        left BUTTON -->
  <button *ngIf="fieldConfig.leftButton" type="button" pButton
          [icon]="fieldConfig.leftButton.icon?fieldConfig.leftButton.icon:''"
          [class]="fieldConfig.leftButton.class?fieldConfig.leftButton.class:''"
          [pTooltip]="fieldConfig.leftButton.tooltip?fieldConfig.leftButton.tooltip:''"
          pRipple [label]="fieldConfig.leftButton.label"
          (click)="fieldConfig.leftButton.command(formRecord); reloadFieldValueMap()"
          [disabled]="this.loading || this.loadingProgressValue < 100
                       || fieldValueMap['disabled']"></button>
  <!--        CHECKBOX Field -->
  <p-toggleButton *ngIf="fieldConfig.type===FieldTypes.CHECKBOX||fieldValueMap['hybridType']===FieldTypes.CHECKBOX"
                  [onIcon]="fieldConfig.onIcon?fieldConfig.onIcon:'fas fa-check'"
                  [offIcon]="fieldConfig.offIcon?fieldConfig.offIcon:'fas fa-times'"
                  [id]="fieldConfig.field"
                  [(ngModel)]="formRecord[fieldConfig.field]"
                  [disabled]="this.loading || this.loadingProgressValue < 100
                       || fieldValueMap['disabled']"
                  [pTooltip]="fieldConfig.label ? fieldConfig.label : 'page.' + this.transPartKey + '.form.' + fieldConfig.field
                   +(!formRecord[fieldConfig.field]&&fieldConfig.useOffLabel?'.off':'')| translate"
                  [onLabel]="fieldConfig.label ? fieldConfig.label : 'page.' + this.transPartKey + '.form.' + fieldConfig.field | translate"
                  [offLabel]="fieldConfig.label ? fieldConfig.label : 'page.' + this.transPartKey + '.form.' + fieldConfig.field
                          +(fieldConfig.useOffLabel?'.off':'') | translate"

                  (onChange)="recordChanged(fieldConfig, $event)">
  </p-toggleButton>
  <!--            &lt;!&ndash;        CHECKBOX Field &ndash;&gt;-->
  <!--            <p-toggleButton *ngIf="fieldConfig.type===FieldTypes.CHECKBOX" onIcon="fas fa-check" offIcon="fas fa-times"-->
  <!--                            [id]="fieldConfig.field"-->
  <!--                            [(ngModel)]="formRecord[fieldConfig.field]"-->
  <!--                            [disabled]="this.loading || this.loadingProgressValue < 100
               || fieldValueMap['disabled']"-->
  <!--                            [onLabel]="'page.' + transPartKey + '.form.' + fieldConfig.field | translate"-->
  <!--                            [offLabel]="'page.' + transPartKey + '.form.not.' + fieldConfig.field | translate"-->
  <!--                            (onChange)="fieldConfig.changed?fieldConfig.changed($event):{};formRecordChange.emit(formRecord)"-->
  <!--                            [hidden]="fieldConfig.hidden?fieldConfig.hidden(formRecord):false">-->
  <!--            </p-toggleButton>-->
  <!--            </p-toggleButton>-->
  <!--        TEXT Field -->
  <input #inputField *ngIf="fieldConfig.type===FieldTypes.TEXT || fieldConfig.type===FieldTypes.EMAIL
                              || fieldValueMap['hybridType']===FieldTypes.TEXT"
         [id]="fieldConfig.field" [type]="fieldConfig.type"
         class="p-inputtext-sm"
         pInputText [(ngModel)]="formRecord[fieldConfig.field]"
         [required]="fieldConfig.required===true"
         [disabled]="this.loading || this.loadingProgressValue < 100
                       || fieldValueMap['disabled']"
         (ngModelChange)="fieldConfig.input?fieldConfig.input($event, formRecord, inputField):{};recordChanged(fieldConfig, $event);"
         [forceFocus]="fieldConfig.focused" [delay]="200" autocomplete="off"
         [minlength]="fieldConfig.min?fieldConfig.min:null" [maxlength]="fieldConfig.max?fieldConfig.max:null"
  />
  <!--          (change)="recordChanged(fieldConfig, $event)"-->
  <!--                   [pTooltip]="fieldConfig.required===true && submitted && !formRecord[fieldConfig.field]?-->
  <!--                      ('page.' + transPartKey + '.form.' + fieldConfig.field | translate )('common.form.required_sing' | translate):''"-->
  <!--        INTERGER Field -->
  <p-inputNumber #inputField
                 *ngIf="fieldConfig.type===FieldTypes.INTEGER||fieldValueMap['hybridType']===FieldTypes.INTEGER"
                 [id]="fieldConfig.field"
                 [min]="fieldConfig.min?fieldConfig.min:null" [max]="fieldConfig.max?fieldConfig.max:null"
                 [(ngModel)]="formRecord[fieldConfig.field]"
                 [required]="fieldConfig.required===true"
                 [disabled]="this.loading || this.loadingProgressValue < 100
                       || fieldValueMap['disabled']"
                 (onInput)="fieldConfig.input?fieldConfig.input($event, formRecord, undefined):{};recordChanged(fieldConfig, $event);"
                 [forceFocus]="fieldConfig.focused" [delay]="200"
  ></p-inputNumber>
  <!--        DECIMAL Field -->
  <p-inputNumber #inputField
                 *ngIf="fieldConfig.type===FieldTypes.DECIMAL||fieldValueMap['hybridType']===FieldTypes.DECIMAL"
                 [id]="fieldConfig.field"
                 [mode]="'decimal'"
                 [min]="fieldConfig.min?fieldConfig.min:null" [max]="fieldConfig.max?fieldConfig.max:null"
                 [minFractionDigits]="fieldValueMap['fractionDigits']?fieldValueMap['fractionDigits']:0"
                 [maxFractionDigits]="fieldValueMap['fractionDigits']||fieldValueMap['fractionDigits']==0?fieldValueMap['fractionDigits']:6"
                 [(ngModel)]="formRecord[fieldConfig.field]"
                 [required]="fieldConfig.required===true"
                 [disabled]="this.loading || this.loadingProgressValue < 100
                       || fieldValueMap['disabled']"
                 (onInput)="fieldConfig.input?fieldConfig.input($event, formRecord, undefined):{};recordChanged(fieldConfig, $event);"
                 [forceFocus]="fieldConfig.focused" [delay]="200" locale="en-uk"
  ></p-inputNumber>
  <!--        PASSWORD Field -->
  <p-password #passwordField
              *ngIf="fieldConfig.type===FieldTypes.PASSWORD||fieldValueMap['hybridType']===FieldTypes.PASSWORD"
              [id]="fieldConfig.field"
              [toggleMask]="true"
              [feedback]="fieldConfig.feedback!=false"
              [(ngModel)]="formRecord[fieldConfig.field]"
              [required]="fieldConfig.required===true"
              [disabled]="this.loading || this.loadingProgressValue < 100
                       || fieldValueMap['disabled']"
              (input)="fieldConfig.input?fieldConfig.input($event, formRecord, undefined):{};recordChanged(fieldConfig, $event);"
              [forceFocus]="fieldConfig.focused" [delay]="200"
              autocapitalize="off"
              spellcheck="false"
  ></p-password>
  <!--        TEXTAREA Field -->
  <textarea #inputField
            *ngIf="fieldConfig.type===FieldTypes.TEXTAREA||fieldValueMap['hybridType']===FieldTypes.TEXTAREA"
            [id]="fieldConfig.field" type="text"
            class="p-inputtext-sm"
            [rows]="5" [cols]="5"
            pInputTextarea autoResize="autoResize" [(ngModel)]="formRecord[fieldConfig.field]"
            [required]="fieldConfig.required===true"
            [disabled]="this.loading || this.loadingProgressValue < 100
                       || fieldValueMap['disabled']"
            (ngModelChange)="fieldConfig.input?fieldConfig.input($event, formRecord, inputField):{};recordChanged(fieldConfig, $event);"
            [forceFocus]="fieldConfig.focused" [delay]="200"
  ></textarea>
  <!--        RICHTEXTAREA Field -->
  <p-editor #inputField *ngIf="fieldConfig.type===FieldTypes.RICHTEXTAREA" [id]="fieldConfig.field"
            [style.height]="'320px'"
            [modules]="richTextEditorModules"
            [(ngModel)]="formRecord[fieldConfig.field]"
            [required]="fieldConfig.required===true"
            [disabled]="this.loading || this.loadingProgressValue < 100
                       || fieldValueMap['disabled']"
            (ngModelChange)="fieldConfig.input?fieldConfig.input($event, formRecord, inputField):{};recordChanged(fieldConfig, $event);"
  ></p-editor>
  <!--     AUTOCOMPLETE Field -->
  <p-autoComplete #autocompField *ngIf="fieldConfig.type===FieldTypes.AUTOCOMPLETE"
                  [name]="fieldConfig.field"
                  [ngModel]="{id: formRecord[fieldConfig.field], text: formRecord[fieldConfig.field], value: undefined}"
                  (onSelect)="autoCompleteSelect(fieldConfig, autocompField, $event)"
                  (onClear)="autoCompleteCleared(fieldConfig, $event)"
                  (completeMethod)="autoCompleteSearch(fieldConfig, autocompField)"
                  (onKeyUp)="autoCompleteSearchKeyUp(fieldConfig, autocompField, $event)"
                  (onDropdownClick)="dropDownClick(fieldConfig, autocompField, $event)"
                  field="text"
                  dataKey="text"
                  appendTo="body" [required]="fieldConfig.required===true"
                  [disabled]="this.loading || this.loadingProgressValue < 100
                       || fieldValueMap['disabled']"
                  [dropdown]="true"
                  [forceFocus]="fieldConfig.focused" [delay]="200" [panelStyleClass]="'white-overlay'">
    <!--            (onDropdownClick)="dropDownClick(fieldConfig, $event)"-->
    <!--              <ng-template let-option pTemplate="item">-->
    <!--                  <div>{{option.text}}</div>-->
    <!--              </ng-template>-->
  </p-autoComplete>
  <!--     DROPDOWN Field -->
  <p-dropdown *ngIf="fieldConfig.type===FieldTypes.DROPDOWN||fieldValueMap['hybridType']===FieldTypes.DROPDOWN"
              [options]="fieldValueMap['options']"
              [ngModel]="(formRecord[fieldConfig.field]?formRecord[fieldConfig.field]+'':'')"
              optionLabel="text"
              [optionValue]="fieldConfig.optionValue ? fieldConfig.optionValue : 'id'" appendTo="body"
              filterBy="text"
              [showClear]="false" [filter]="fieldConfig.filter"
              [placeholder]="('common.form.select_sing_placeholder' | translate )+'&nbsp;'
              +(fieldConfig.label?fieldConfig.label:('page.'+transPartKey+'.form.' +fieldConfig.field| translate ))"
              [required]="fieldConfig.required===true"
              (onChange)="recordChanged(fieldConfig, $event)"
              [disabled]="this.loading || this.loadingProgressValue < 100
                       || fieldValueMap['disabled']"
              [virtualScroll]="false" virtualScrollItemSize="10"
              [forceFocus]="fieldConfig.focused" [delay]="200" [panelStyleClass]="'white-overlay'"
  >
    <ng-template pTemplate="selectedItem">
      <div>
        <i *ngIf="fieldConfig.icon"
           [class]="fieldValueMap['icon']" [innerHTML]="fieldValueMap['iconValue']"></i>
        {{
          fieldValueMap['findOptionText'] ?
            fieldValueMap['findOptionText']
            : (fieldValueMap['options'] | findOptionTextPipe: formRecord[fieldConfig.field])
        }}
      </div>
    </ng-template>
    <ng-template let-option pTemplate="item">
      <div>
        <i *ngIf="fieldConfig.icon"
           [class]="fieldValueMap['iconItem'+'_'+option.id]">
          {{ fieldValueMap['iconValueItem' + '_' + option.id] }}</i>
        {{ option.text }}
      </div>
    </ng-template>
  </p-dropdown>
  <!--        MULTISELECT Field -->
  <p-multiSelect *ngIf="fieldConfig.type===FieldTypes.MULTISELECT||fieldValueMap['hybridType']===FieldTypes.MULTISELECT"
                 [options]="fieldValueMap['options']"
                 [ngModel]="(formRecord[fieldConfig.field]?formRecord[fieldConfig.field]:[])"
                 optionLabel="text" display="chip"
                 [optionValue]="fieldConfig.optionValue ? fieldConfig.optionValue : 'id'" appendTo="body"
                 filterBy="text"
                 [showHeader]="fieldConfig.filter"
                 [required]="fieldConfig.required===true"
                 (onChange)="recordChanged(fieldConfig, $event)"
                 [disabled]="this.loading || this.loadingProgressValue < 100
                       || fieldValueMap['disabled']"
                 [virtualScroll]="false" virtualScrollItemSize="10"
                 [forceFocus]="fieldConfig.focused" [delay]="200" [class]="'white-overlay'" [panelStyleClass]="'white-overlay'"
  >
    <ng-template let-option pTemplate="item">
      <div>
        <i *ngIf="fieldConfig.icon"
           [class]="fieldValueMap['iconItem'+'_'+option.id]">
          {{ fieldValueMap['iconValueItem' + '_' + option.id] }}</i>
        {{ option.text }}
      </div>
    </ng-template>
  </p-multiSelect>
  <!--        MULTISELECT GROUP Field -->
  <p-multiSelect
    *ngIf="fieldConfig.type===FieldTypes.MULTISELECT_GROUP||fieldValueMap['hybridType']===FieldTypes.MULTISELECT_GROUP"
    [options]="fieldValueMap['options']"
    [group]="true"
    [ngModel]="(formRecord[fieldConfig.field]?formRecord[fieldConfig.field]:[])"
    optionLabel="text" display="chip"
    [optionValue]="fieldConfig.optionValue ? fieldConfig.optionValue : 'id'" appendTo="body"
    filterBy="text"
    [showHeader]="fieldConfig.filter"
    [required]="fieldConfig.required===true"
    (onChange)="recordChanged(fieldConfig, $event)"
    [disabled]="this.loading || this.loadingProgressValue < 100
                       || fieldValueMap['disabled']"
    [virtualScroll]="false" virtualScrollItemSize="10"
    [forceFocus]="fieldConfig.focused" [delay]="200" [panelStyleClass]="'white-overlay'"
  >
    <ng-template let-group pTemplate="group">
      <div>
        <i *ngIf="fieldConfig.icon"
           [class]="fieldValueMap['iconItem'+'_'+group.id]">
          {{ fieldValueMap['iconValueItem' + '_' + group.id] }}</i>
        {{ group.text }}
      </div>
    </ng-template>
    <ng-template let-option pTemplate="item">
      <div>
        <i *ngIf="fieldConfig.icon"
           [class]="fieldValueMap['iconItem'+'_'+option.id]">
          {{ fieldValueMap['iconValueItem' + '_' + option.id] }}</i>
        {{ option.text }}
      </div>
    </ng-template>
  </p-multiSelect>
  <!--        MULTITEXT Field -->
  <p-chips *ngIf="fieldConfig.type===FieldTypes.MULTITEXT||fieldValueMap['hybridType']===FieldTypes.MULTITEXT"
           [separator]="','"
           [ngModel]="(formRecord[fieldConfig.field]?formRecord[fieldConfig.field]:[])"
           [required]="fieldConfig.required===true"
           (onAdd)="multiTextAdd($event.value, fieldConfig.field, fieldConfig.changed);formRecordChange.emit(formRecord);"
           (onRemove)="multiTextRemove($event.value, fieldConfig.field, fieldConfig.changed);formRecordChange.emit(formRecord);"
           [allowDuplicate]="false"
           [addOnBlur]="true"
           [addOnTab]="true"
           [disabled]="this.loading || this.loadingProgressValue < 100
                       || fieldValueMap['disabled']"
           [placeholder]="'common.form.multitext_placeholder' | translate"
           [forceFocus]="fieldConfig.focused" [delay]="200"
  >
  </p-chips>
  <!--        MULTILISTBOX Field -->
  <p-listbox *ngIf="fieldConfig.type===FieldTypes.LISTBOX"
             [options]="fieldValueMap['options']"
             [ngModel]="(formRecord[fieldConfig.field]?formRecord[fieldConfig.field]:[])" optionLabel="text"
             [optionValue]="fieldConfig.optionValue ? fieldConfig.optionValue : 'id'"
             [filter]="fieldConfig.filter" checkbox="true"
             [required]="fieldConfig.required===true"
             (onChange)="recordChanged(fieldConfig, $event)"
             [disabled]="this.loading || this.loadingProgressValue < 100
                       || fieldValueMap['disabled']"
             [multiple]="true"
             [forceFocus]="fieldConfig.focused" [delay]="200"
  >
    <ng-template let-option pTemplate="item">
      <div>
        <i *ngIf="fieldConfig.icon"
           [class]="fieldValueMap['iconItem'+'_'+option.id]" [innerHTML]="fieldValueMap['iconValue']"></i>
        {{ option.text }}
      </div>
    </ng-template>
  </p-listbox>
  <!--        PICKLIST Field -->
  <!--  [listStyle]="{ 'max-height': '30rem' }" header=""-->
  <p-pickList *ngIf="fieldConfig.type===FieldTypes.PICKLIST"
              [source]="fieldValueMap['options']"
              [target]="(formRecord[fieldConfig.field]?formRecord[fieldConfig.field]:[])"
              [sourceHeader]="fieldConfig.headerTitle1?fieldConfig.headerTitle1:'Available'"
              [targetHeader]="fieldConfig.headerTitle2?fieldConfig.headerTitle2:'Selected'"
              [dragdrop]="fieldConfig.dragdrop !== false"
              [keepSelection]="true"
              [responsive]="true"
              breakpoint="576px"
              [sourceStyle]="{ height: '30rem' }"
              [targetStyle]="{ height: '30rem' }"
              (onMoveToTarget)="onPickListMoveToTarget(fieldConfig, $event)"
              (onMoveAllToTarget)="onPickListMoveToTarget(fieldConfig, $event)"
              (onMoveToSource)="onPickListChange(fieldConfig)"
              (onMoveAllToSource)="onPickListChange(fieldConfig)"
              (onTargetReorder)="onPickListChange(fieldConfig)"
              (onSourceReorder)="onPickListChange(fieldConfig)"
  >
    <ng-template let-option pTemplate="item">
      <div class="flex flex-wrap align-items-left gap-3">
        <i *ngIf="fieldConfig.icon"
           [class]="fieldValueMap['iconItem'+'_'+option.id]"
           [innerHTML]="fieldValueMap['iconValue']"></i>
        <span>{{ option.text }}</span>
      </div>
    </ng-template>
  </p-pickList>
  <!--        CRON Field -->
  <cc-cron-field *ngIf="fieldConfig.type===FieldTypes.CRON"
                 [id]="fieldConfig.field"
                 [(formRecord)]="formRecord[fieldConfig.field]"
                 [required]="fieldConfig.required===true"
                 [disabled]="this.loading || this.loadingProgressValue < 100
                       || fieldValueMap['disabled']"
                 (change)="recordChanged(fieldConfig, $event)"
  ></cc-cron-field>

  <!--        Date -->
  <p-calendar *ngIf="fieldConfig.type===FieldTypes.DATE||fieldValueMap['hybridType']===FieldTypes.DATE"
              [id]="fieldConfig.field"
              [(ngModel)]="formRecord[fieldConfig.field]"
              [required]="fieldConfig.required===true"
              [disabled]="this.loading || this.loadingProgressValue < 100
                       || fieldValueMap['disabled']"
              (ngModelChange)="recordChanged(fieldConfig, $event)"
              appendTo="body"
              [maxDate]="fieldConfig.maxDate"
              [minDate]="fieldConfig.minDate"
              [forceFocus]="fieldConfig.focused" [delay]="200"
              [dateFormat]="fieldConfig.format?fieldConfig.format:'dd/mm/yy'" dataType="string"
              [panelStyleClass]="'white-overlay'"
              [selectionMode]="fieldConfig.dateSelectionMode?fieldConfig.dateSelectionMode:'single'"
              [view]="fieldConfig.dateView?fieldConfig.dateView:'date'"
  ></p-calendar>
  <!--        DateTime -->
  <p-calendar *ngIf="fieldConfig.type===FieldTypes.DATETIME||fieldValueMap['hybridType']===FieldTypes.DATETIME"
              [id]="fieldConfig.field"
              [(ngModel)]="formRecord[fieldConfig.field]"
              [required]="fieldConfig.required===true"
              [disabled]="this.loading || this.loadingProgressValue < 100
                       || fieldValueMap['disabled']"
              (ngModelChange)="recordChanged(fieldConfig, $event)"
              hourFormat="24" [showTime]="true" [showSeconds]="true" appendTo="body"
              [dateFormat]="fieldConfig.format?fieldConfig.format:'yyyy-MM-dd HH:mm:ss'" dataType="string"
              [forceFocus]="fieldConfig.focused" [delay]="200" [panelStyleClass]="'white-overlay'"
  ></p-calendar>
  <!--          dateFormat="dd/mm/yy hh:MM" dataType="string"-->
  <!--        Time -->
  <p-calendar *ngIf="fieldConfig.type===FieldTypes.TIME||fieldValueMap['hybridType']===FieldTypes.TIME"
              [id]="fieldConfig.field"
              [(ngModel)]="formRecord[fieldConfig.field]"
              [required]="fieldConfig.required===true"
              [disabled]="this.loading || this.loadingProgressValue < 100
                       || fieldValueMap['disabled']"
              (ngModelChange)="recordChanged(fieldConfig, $event)"
              hourFormat="24" [timeOnly]="true" [showSeconds]="true" appendTo="body"
              [forceFocus]="fieldConfig.focused" [delay]="200" [panelStyleClass]="'white-overlay'"
  ></p-calendar>

  <!--        RichField -->
  <cc-rich-field #ccSubForm *ngIf="fieldConfig.type===FieldTypes.RICHFIELD"
                 [fieldName]="'page.' + transPartKey + '.form.' + fieldConfig.field | translate"
                 [formRecords]="(formRecord[fieldConfig.field]?formRecord[fieldConfig.field]:[])"
                 [formRichFieldConfig]="fieldConfig.richFieldConfig"
                 [transPartKey]="transPartKey"
                 [required]="fieldConfig.required===true"
                 (formRecordsChange)="recordChanged(fieldConfig, $event)"
                 [disabled]="this.loading || this.loadingProgressValue < 100
                       || fieldValueMap['disabled']"
                 [forceFocus]="fieldConfig.focused" [delay]="200"
  >
  </cc-rich-field>

  <!--        ADDDELETEFIELD -->
  <cc-add-delete-field #ccSubForm *ngIf="fieldConfig.type===FieldTypes.ADDDELETEFIELD"
                       [formRecords]="(formRecord[fieldConfig.field]?formRecord[fieldConfig.field]:[])"
                       [formRichFieldConfig]="fieldConfig.richFieldConfig"
                       [transPartKey]="transPartKey"
                       [required]="fieldConfig.required===true"
                       (formRecordsChange)="recordChanged(fieldConfig, $event)"
                       [disabled]="this.loading || this.loadingProgressValue < 100
                       || fieldValueMap['disabled']"
                       [forceFocus]="fieldConfig.focused" [delay]="200"
  >
  </cc-add-delete-field>

  <!--        single RichField -->
  <cc-single-rich-field #ccSubForm *ngIf="fieldConfig.type===FieldTypes.SINGLERICHFIELD"
                        [fieldName]="'page.' + transPartKey + '.form.' + fieldConfig.field | translate"
                        [formRecord]="(formRecord[fieldConfig.field]?formRecord[fieldConfig.field]:{})"
                        [formRichFieldConfig]="fieldConfig.richFieldConfig"
                        [transPartKey]="transPartKey"
                        [required]="fieldConfig.required===true"
                        (formRecordChange)="recordChanged(fieldConfig, $event)"
                        [disabled]="this.loading || this.loadingProgressValue < 100
                       || fieldValueMap['disabled']"
                        [forceFocus]="fieldConfig.focused" [delay]="200"
  >
  </cc-single-rich-field>
  <!--        MapField -->
  <cc-map-field #ccSubForm *ngIf="fieldConfig.type===FieldTypes.MAPFIELD"
                [fieldName]="'page.' + transPartKey + '.form.' + fieldConfig.field | translate"
                [formRecordMap]="(formRecord[fieldConfig.field]?formRecord[fieldConfig.field]:{})"
                [transPartKey]="transPartKey"
                [required]="fieldConfig.required===true"
                (formRecordMapChange)="recordChanged(fieldConfig, $event)"
                [disabled]="this.loading || this.loadingProgressValue < 100
                       || fieldValueMap['disabled']"
                [forceFocus]="fieldConfig.focused" [delay]="200"
  >
  </cc-map-field>
  <!--        TableFormField -->
  <cc-table-form-field #ccSubForm *ngIf="fieldConfig.type===FieldTypes.TABLEFORMFIELD"
                       [formRecords]="(formRecord[fieldConfig.field]?formRecord[fieldConfig.field]:[])"
                       [formRichFieldConfig]="fieldConfig.richFieldConfig"
                       [transPartKey]="transPartKey"
                       [required]="fieldConfig.required===true"
                       (formRecordsChange)="recordChanged(fieldConfig, $event)"
                       [disabled]="this.loading || this.loadingProgressValue < 100
                       || fieldValueMap['disabled']"
                       [forceFocus]="fieldConfig.focused" [delay]="200"
  >
  </cc-table-form-field>
  <!--        FILE UPLOAD -->
    <p-fileUpload #fileUpload *ngIf="fieldConfig.type===FieldTypes.FILEUPLOAD" mode="basic" chooseIcon="pi pi-upload"
                  chooseLabel="Choose File" (onSelect)="fileSelected(fieldConfig, $event, fileUpload)"
                   [accept]="fieldConfig.accept" maxFileSize="10000000">
    </p-fileUpload>
    <p *ngIf="fieldConfig.type===FieldTypes.FILEUPLOAD" class="p-5">{{ formRecord[fieldConfig.field]?'Selected File: '+formRecord[fieldConfig.field].name:'&nbsp;' }}</p>
<!--  </div>-->
  <!--        BUTTONS -->
  <span *ngIf="fieldConfig.type===FieldTypes.BUTTONS&&fieldConfig.buttons"
        class="d-flex">
            <button *ngFor="let buttonConf of fieldConfig.buttons; let i = index"
                    class="ws-nowrap {{buttonConf.class?buttonConf.class:''}}"
                    type="button" pButton
                    [icon]="buttonConf.icon?buttonConf.icon:''"
                    [pTooltip]="buttonConf.tooltip?buttonConf.tooltip:''"
                    [class.mr-5]="i<fieldConfig.buttons.length-1"
                    pRipple [label]="buttonConf.label"
                    (click)="buttonConf.command(formRecord); reloadFieldValueMap()"
                    [disabled]="this.loading || this.loadingProgressValue < 100
                       || fieldValueMap['disabled'] || fieldValueMap['disabled_btn'+i]"></button>
          </span>
  <!--        ERROR MESSAGE -->
  <!--            <small class="p-invalid"-->
  <!--                   *ngIf="fieldConfig.required===true && submitted && !formRecord[fieldConfig.field]">-->
  <!--              {{ 'page.' + transPartKey + '.form.' + fieldConfig.field | translate }}-->
  <!--              {{ 'common.form.required_sing' | translate }}</small>-->
  <!--        icon NONE -->
  <i *ngIf="fieldConfig.type===FieldTypes.NONE&&fieldConfig.icon"
     [class]="fieldValueMap['icon']" [innerHTML]="fieldValueMap['iconValue']"></i>

  <!--        right BUTTON -->
  <button *ngIf="fieldConfig.rightButton" type="button" pButton
          [icon]="fieldConfig.rightButton.icon?fieldConfig.rightButton.icon:''"
          [class]="fieldConfig.rightButton.class?fieldConfig.rightButton.class:''"
          [pTooltip]="fieldConfig.rightButton.tooltip?fieldConfig.rightButton.tooltip:''"
          pRipple [label]="fieldConfig.rightButton.label"
          (click)="fieldConfig.rightButton.command($event, formRecord); reloadFieldValueMap()"
          [disabled]="this.loading || this.loadingProgressValue < 100
                       || fieldValueMap['disabled']"></button>

</div>
<small class="p-invalid"
       [textContent]="fieldValueMap['validate'] | translate"></small>
<!--      </div>-->


